export const planPermitVehicleChanges = ({
	current,
	submitted,
}: {
	current: { id: number; plate: string; state: string }[];
	submitted: { id?: number; plate: string; state: string }[];
}) => {
	const currentById = new Map(current.map((vehicle) => [vehicle.id, vehicle]));
	const submittedIds = new Set(submitted.map((vehicle) => vehicle.id));
	const vehiclesToUpdate = submitted.flatMap((vehicle) => {
		const existing = vehicle.id === undefined ? undefined : currentById.get(vehicle.id);
		if (!existing || (existing.plate === vehicle.plate && existing.state === vehicle.state)) {
			return [];
		}
		return [{ id: existing.id, plate: vehicle.plate, state: vehicle.state }];
	});
	const removedVehicles = current.filter((vehicle) => !submittedIds.has(vehicle.id));
	const newVehicles: { plate: string; state: string }[] = [];
	for (const vehicle of submitted.filter((submittedVehicle) => submittedVehicle.id === undefined)) {
		const restoredIndex = removedVehicles.findIndex(
			(removedVehicle) => removedVehicle.plate === vehicle.plate && removedVehicle.state === vehicle.state,
		);
		if (restoredIndex === -1) {
			newVehicles.push(vehicle);
		} else {
			removedVehicles.splice(restoredIndex, 1);
		}
	}
	const vehiclesToAdd: { plate: string; state: string }[] = [];
	for (const vehicle of newVehicles) {
		const replacedVehicle = removedVehicles.shift();
		if (replacedVehicle) {
			vehiclesToUpdate.push({ id: replacedVehicle.id, plate: vehicle.plate, state: vehicle.state });
		} else {
			vehiclesToAdd.push({ plate: vehicle.plate, state: vehicle.state });
		}
	}
	return {
		vehiclesToUpdate,
		vehiclesToRemove: removedVehicles.map(({ id }) => ({ id })),
		vehiclesToAdd,
	};
};
